import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import Loader from 'Components/Forms/Loader';
import SearchToolbar from 'Components/Forms/SearchToolbar';
import PartnersTable from 'FeatureModules/Partner/Components/PartnersTable/PartnersTable';
import usePartners from 'FeatureModules/Partner/Components/hooks/usePartners';
import React, { FC, useState } from 'react';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import { EPartnerHeaderColumnEnum } from '../PartnersTable/partnerHeaderColumns';
import EmptySearch from 'Components/EmptySearch';
import ErrorState from 'Components/ErrorState';

const SearchbarContainer = styled(Box)(() => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  top: -35,
  left: 0,
  zIndex: 9,
}));

interface IProps {
  selectedPartner?: IBasePartnerCompany;
  setSelectedPartner: (partner: IBasePartnerCompany) => void;
}

/**
 * @deprecated use PartnerSelection instead
 */
const PartnerSelector: FC<IProps> = ({ selectedPartner, setSelectedPartner }) => {
  // Using custom search, and not the one from usePartner, because we don't want it in the query params
  const [page, setPage] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { partners, loading, error } = usePartners({ customSearch: searchTerm });

  const handleSearchTermChange = (term: string) => {
    setSearchTerm(term);
    setPage(0);
  };

  if (loading) {
    return <Loader />;
  }
  if (error || !partners) {
    return <ErrorState />;
  }

  return (
    <Box position="relative" mt={7} mb={3} minHeight={400}>
      <SearchbarContainer>
        <SearchToolbar
          setSearchTerm={handleSearchTermChange}
          searchTerm={searchTerm}
          data-testid="document-search-input"
          placeholder="Search partners"
          className="search-input"
        />
      </SearchbarContainer>
      <PartnersTable
        page={page}
        hideHeader
        selectedPartner={selectedPartner}
        partners={partners}
        onSelect={setSelectedPartner}
        columns={[EPartnerHeaderColumnEnum.TITLE]}
        onPageChange={setPage}
      />

      {!partners.length && <EmptySearch />}
    </Box>
  );
};

export default PartnerSelector;
